@use "Styles/mixins";

:host {
    display: block;
    width: 100%;
}

.content {
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.heading {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 36px;
    font-weight: 600;
    color: mixins.get-color(text, text-primary);
    line-height: 1.1;
    margin: 0 0 4px;
    padding: 0;
    text-align: center;
    text-wrap: balance;

    @media (max-width: 1024px) {
        font-size: 24px;
        gap: 8px;
    }
}

.heading__sparkle {
    color: mixins.get-color(accent, primary-weak);
    flex-shrink: 0;

    @media (max-width: 767px) {
        display: none;
    }
}

.subtitle {
    font-size: 16px;
    color: mixins.get-color(text, text-secondary);
    text-align: center;
    line-height: 1.5;
    margin: 0 0 32px;
    padding: 0;
    text-wrap: pretty;

    @media (max-width: 767px) {
        padding: 0 16px;
    }
}

.composer {
    width: 100%;
    max-width: 768px;
    margin-bottom: 24px;
}
